export default "__VITE_ASSET__jGu9PJvq__"